function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:none;stroke:#dfe2e1;stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "arrow-gray");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "art"
}, React.createElement("path", {
  className: "cls-1",
  d: "M12.76,3.5C12.13,11.31,6.82,25.7,9.43,25A53.37,53.37,0,0,1,27,23.11,92.84,92.84,0,0,1,12.14,39.24a73.82,73.82,0,0,0,17.94.7,20.12,20.12,0,0,1-4.47,5.73L7.89,63.35l17.39-.6a22.34,22.34,0,0,0-5.83,16.43c.32,5.36,4.23,15.93,4.06,15.9"
}), React.createElement("path", {
  className: "cls-1",
  d: "M3.5,79.32a93.6,93.6,0,0,0,20.28,20.82A167.33,167.33,0,0,0,35.57,78.49"
}));

var SvgArrowGray = function SvgArrowGray(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 39.07 103.64",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : React.createElement("title", null, title), _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-gray.3151ccbd.svg";
export { ForwardRef as ReactComponent };